function updateProductStamps() {
  const mediaItems = document.querySelectorAll('.product__media-item');

  mediaItems.forEach((item) => {
    const img = item.querySelector('img');

    if (!img) return;

    const src = img.currentSrc || img.src;

    if (!src || item.dataset.stampChecked === src) return;

    const image = new Image();
    image.crossOrigin = 'anonymous';

    image.onload = function () {
      const canvas = document.createElement('canvas');
      const ctx = canvas.getContext('2d', {
        willReadFrequently: true
      });

      canvas.width = 30;
      canvas.height = 30;

      /*
       Look at the bottom-right section of the image,
       approximately where your stamp sits.
      */
      const sampleWidth = image.width * 0.28;
      const sampleHeight = image.height * 0.28;

      const sampleX = image.width - sampleWidth;
      const sampleY = image.height - sampleHeight;

      ctx.drawImage(
        image,
        sampleX,
        sampleY,
        sampleWidth,
        sampleHeight,
        0,
        0,
        30,
        30
      );

      try {
        const pixels = ctx.getImageData(0, 0, 30, 30).data;

        let totalBrightness = 0;
        let pixelCount = 0;

        for (let i = 0; i < pixels.length; i += 4) {
          const r = pixels[i];
          const g = pixels[i + 1];
          const b = pixels[i + 2];

          const brightness =
            (0.299 * r) +
            (0.587 * g) +
            (0.114 * b);

          totalBrightness += brightness;
          pixelCount++;
        }

        const averageBrightness =
          totalBrightness / pixelCount;

        /*
         145 is the cut-off.
         
         Below 145 = dark background → cream stamp
         Above 145 = light background → brown stamp
        */
        if (averageBrightness < 145) {
          item.classList.add('stamp-light');
        } else {
          item.classList.remove('stamp-light');
        }

        item.dataset.stampChecked = src;

      } catch (error) {
        console.warn('Could not analyse product image.', error);
      }
    };

    image.src = src;
  });
}

document.addEventListener('DOMContentLoaded', updateProductStamps);

const productStampObserver = new MutationObserver(() => {
  requestAnimationFrame(updateProductStamps);
});

productStampObserver.observe(document.body, {
  childList: true,
  subtree: true
});